"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
var React = require("react");
var DOMHelper_1 = require("./DOMHelper");
var AppHost_1 = require("@twii/core-ui-fabric/lib/component/AppHost");
var Window_1 = require("./Window");
var AppPortal = /** @class */ (function () {
    function AppPortal(root, el, window, onDestroy) {
        this._root = root;
        this._el = el;
        this._window = window;
        this._onDestroy = onDestroy;
        ReactDOM.render(React.createElement(Window_1.Window, { window: this._window },
            React.createElement(AppHost_1.AppHostContainer, { host: this._window.appHost })), this._el);
    }
    AppPortal.prototype.setViewport = function (left, top, width, height) {
        var clientBounds = this._el.getBoundingClientRect();
        var sizeChanged = width !== clientBounds.width || height !== clientBounds.height;
        var visible = width > 0 && height > 0;
        var s = this._el.style;
        s.top = (visible ? top : -1) + "px";
        s.left = (visible ? left : -1) + "px";
        s.bottom = "";
        s.right = "";
        s.width = width + "px";
        s.height = height + "px";
        s.overflow = "hidden";
        if (sizeChanged) {
            this._window.appHost.emit({ type: "resize" });
            DOMHelper_1.dispatchWindowResize();
        }
    };
    AppPortal.prototype.destroy = function () {
        ReactDOM.unmountComponentAtNode(this._el);
        this._root.removeChild(this._el);
        if (this._onDestroy) {
            this._onDestroy(this._window);
        }
    };
    return AppPortal;
}());
exports.AppPortal = AppPortal;
var AppPortalManager = /** @class */ (function () {
    function AppPortalManager(root) {
        var _this = this;
        this._portalMap = {};
        this._onPortalDestroyed = function (window) {
            delete _this._portalMap[window.id];
        };
        this._root = root;
    }
    AppPortalManager.prototype.getPortal = function (window) {
        var portal = this._portalMap[window.id];
        if (!portal) {
            var doc = this._root.ownerDocument;
            var el = doc.createElement("div");
            var s = el.style;
            s.position = "absolute";
            s.zIndex = "1";
            this._root.appendChild(el);
            portal = new AppPortal(this._root, el, window, this._onPortalDestroyed);
            this._portalMap[window.id] = portal;
        }
        return portal;
    };
    AppPortalManager.prototype.destroyPortal = function (window) {
        var portal = this._portalMap[window.id];
        if (portal) {
            portal.destroy();
        }
    };
    AppPortalManager.prototype.destroy = function () {
        var _this = this;
        Object.keys(this._portalMap).forEach(function (key) {
            _this._portalMap[key].destroy();
        });
    };
    return AppPortalManager;
}());
exports.AppPortalManager = AppPortalManager;
